// extracted by mini-css-extract-plugin
export default {"back":"BackLink_back__lGicK","icon":"BackLink_icon__u1qDF"};